import { render, staticRenderFns } from "./InstitutionDetails.vue?vue&type=template&id=05b4d121&scoped=true"
import script from "./InstitutionDetails.vue?vue&type=script&lang=js"
export * from "./InstitutionDetails.vue?vue&type=script&lang=js"
import style0 from "./InstitutionDetails.vue?vue&type=style&index=0&id=05b4d121&prod&scoped=true&lang=css"
import style1 from "./InstitutionDetails.vue?vue&type=style&index=1&id=05b4d121&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b4d121",
  null
  
)

export default component.exports